import React from "react";
import { Routes, Route } from "react-router-dom";
import ListPartner from "../Components/Partner Roles/listPartnerRoles";
import ViewPartner  from "../Components/Partner Roles/viewPartnerRoles";

const PartnerRolesRoutes = () => {
  return (
    <Routes>
      <Route path="/partner_roles" element={<ListPartner></ListPartner>}></Route>
      <Route path="/partner_roles/:id" element={<ViewPartner ></ViewPartner>}></Route>
    </Routes>
  );
};

export default PartnerRolesRoutes;
